export default __webpack_public_path__ + "static/media/Group_1918.2ddaca5f.png";